import { render, staticRenderFns } from "./PtuErrosDownload.vue?vue&type=template&id=561966ea"
import script from "./PtuErrosDownload.vue?vue&type=script&lang=js"
export * from "./PtuErrosDownload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports